import {ObjectUtils} from '@app/core/utils/object.utils';
import {ERole} from '../enums/role.enum';
import {ICustomerOrganization, ICustomerProfileState, IOrganizationState} from '../models/header.model';

export class HeaderUtils {
  static getCustomerAddress(customerAddress: IOrganizationState): string {
    return [
      customerAddress?.address,
      customerAddress?.city?.name ?? customerAddress?.cityName,
      customerAddress?.region?.name ?? customerAddress?.regionName,
      customerAddress?.country?.name ?? customerAddress?.countryName,
      customerAddress?.zipPostalCode,
    ]
      .filter(Boolean)
      .join(', ');
  }

  static validateCustomerProfileProperties(customerProfileState: {
    customerProfile: ICustomerProfileState | null;
    customerOrganization: ICustomerOrganization | null;
    customerOrganizationAddress: string;
  }): boolean {
    if (customerProfileState?.customerProfile?.role === ERole.Doctor) {
      return ObjectUtils.hasEmptyProperties({
        id: customerProfileState?.customerProfile?.id,
        firstName: customerProfileState?.customerProfile?.firstName,
        lastName: customerProfileState?.customerProfile?.lastName,
        email: customerProfileState?.customerProfile?.aspNetUsers?.email,
        medicalSpecialtyId: customerProfileState?.customerProfile?.medicalSpecialty?.id,
        doctorId: customerProfileState?.customerProfile?.doctorId,
      });
    } else {
      return ObjectUtils.hasEmptyProperties({
        id: customerProfileState?.customerProfile?.id,
        firstName: customerProfileState?.customerProfile?.firstName,
        lastName: customerProfileState?.customerProfile?.lastName,
        email: customerProfileState?.customerProfile?.aspNetUsers?.email,
        medicalSpecialtyId: customerProfileState?.customerProfile?.medicalSpecialty?.id,
      });
    }
  }
}
